import React from 'react'
import { Mail } from 'lucide-react'

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between space-y-3 sm:space-y-0">
          <div className="flex items-center space-x-2">
            <span className="text-sm font-semibold text-accent">G2Bulk</span>
            <span className="text-text-muted text-xs">© {year}</span>
          </div>

          <a href="mailto:support@g2bulk.com" className="flex items-center space-x-1.5 text-text-muted hover:text-accent text-sm transition-colors">
            <Mail size={14} />
            <span>support@g2bulk.com</span>
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
